//Header overlay

function adjustTemplateIndexPadding() {
    const header = document.getElementById("shopify-section-header-classic");
    const templatePage = document.querySelector('[id*=template-page-pf], [id*=template-index], [id*=template-collection-pf], [id*=template-collection]');
    if (templatePage) {
        templatePage.classList.add('topped');
        const headerHeight = header.offsetHeight;
        templatePage.style.marginTop = `-${headerHeight}px`;
        header.classList.add('transparent');
    }
}
adjustTemplateIndexPadding();
window.addEventListener("resize", adjustTemplateIndexPadding);


//Home slider

function updateRightOffset() {
  const currentSlide = document.querySelector('.pf-slide.is-current.is-visible');
  const slideWidth = currentSlide.offsetWidth;
  const slidePosition = currentSlide.getBoundingClientRect();
  const rightOffset = window.innerWidth - (slidePosition.left + slideWidth);
  console.log(rightOffset);
  const rightBtn = document.querySelector('.pf-slider-next.nav-style-1');
  rightBtn.style.right = `${rightOffset - rightBtn.clientWidth/2}px`;
}

window.onload = function() {
  if (window.location.pathname === '/' || window.location.pathname === '/index.html') {
    updateRightOffset();
    window.addEventListener('resize', updateRightOffset);
  }
};


//Collection Slider

window.onload = function() {
  var bodyClasses = Array.from(document.body.classList);
  var hasProduct = bodyClasses.some(function(className) {
    return className.includes('product');
  });
  if (hasProduct) {
    var img = document.getElementById('offset_img');
    var imgOffset = img.getBoundingClientRect().left;
    var collectionSlider = document.querySelector('.collection_slider');
    collectionSlider.style.marginLeft = imgOffset + "px";
  }
};


//External links in new tab

window.onload = function() {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
};